import React from 'react';
import { buttons } from 'seal-ui-components';
import useWindowSize from '@Hooks/useWindowSize';
import DialogPopUp from '@Components/UI/DialogPopUp/DialogPopUp';
import Divider from '@Components/UI/Divider';
import { Instruction, InstructionContainer } from '../../MarkupPanel.style';
import { ButtonsContainer, PopupInner, Title, BodyText } from './PopupConfirm.style';

const modalProps = { isDarkOverlay: true, isBlocking: true };

const PopupConfirm = ({ isHidden, closeModal, onConfirm, onCancel }) => {
    const size = useWindowSize();

    return (
        <DialogPopUp
            hidden={isHidden}
            onDismiss={closeModal}
            modalProps={modalProps}
            className="ms-Dialog-confirm"
        >
            <PopupInner>
                <Title>Apply Markup</Title>
                <Divider />
                <BodyText>
                    <InstructionContainer>
                        <Instruction width={0.85 * size.width}>
                            Applying or clearing markup will overwrite any existing color formatting
                        </Instruction>

                        <Instruction width={0.85 * size.width}>
                            Save your document and disable track changes before applying or clearing
                            markup
                        </Instruction>

                        <Instruction width={0.85 * size.width}>
                            This operation may take time to complete
                        </Instruction>
                    </InstructionContainer>
                </BodyText>
                <ButtonsContainer>
                    <buttons.Button size="medium" appearance="secondary" onClick={onCancel}>
                        Cancel
                    </buttons.Button>
                    <buttons.Button size="medium" appearance="primary" onClick={onConfirm}>
                        Continue
                    </buttons.Button>
                </ButtonsContainer>
            </PopupInner>
        </DialogPopUp>
    );
};

export { PopupConfirm };
